import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import { setLastRouter, getStorage, goBack, setStorage } from '../libs/utils'
import { Dialog } from 'vant'

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history',
})
const LOGIN_PAGE_NAME = 'login'
const homeName = 'index'

var checkLogin = (to, token, next) => {
  let order_id = to.query.orderid
  if (order_id) {
    window.localStorage.setItem('order_id', order_id)
  }
  if (to.meta.noLogin !== true) {
    if (!token && to.name !== LOGIN_PAGE_NAME) {
      // 未登录且要跳转的页面不是登录页 记录跳转地址后 登录成功后回调
      next({
        name: LOGIN_PAGE_NAME, // 跳转到登录页
      })
    } else {
      next()
    }
  } else {
    if (!token && to.name === LOGIN_PAGE_NAME) {
      // setLastRouter(to)
      // 未登陆且要跳转的页面是登录页
      next() // 跳转
    } else if (token && to.name === LOGIN_PAGE_NAME) {
      // 已登录且要跳转的页面是登录页
      next({
        name: homeName, // 跳转到homeName页
      })
    } else {
      next()
    }
  }
}
router.beforeEach((to, from, next) => {
  if (to.meta.showloading) store.commit('handleSpinShow', true)
  if (to.name == 'login' && from.name) {
    setLastRouter(from)
  }
  //appInfo 原始链接
  if (to.query && to.query.stid) window.localStorage.setItem('stid', to.query.stid)
  if (to.query && to.query.orderid) {
    let query = {}
    query.orderid = to.query.orderid
    query.orderno = to.query.orderno
    query.code = to.query.scode
    query.gname = to.query.gname
    window.localStorage.setItem('orderpay', JSON.stringify(query))
  }
  if (to.query && to.query.ei) store.dispatch('handleAppInfo', to.query.ei)
  let appInfo = getStorage('appInfo')
  const token = getStorage('userInfo')
  if (!appInfo) {
    store.dispatch('getLaunchInfo').then(() => {
      checkLogin(to, token, next)
    })
  } else {
    checkLogin(to, token, next)
  }
})

router.afterEach((to) => {
  //ios wechat sdk
  if (window.__wxjs_is_wkwebview) {
    // IOS
    if (window.entryUrl == '' || window.entryUrl == undefined) {
      var url = `${window.location.origin}${to.fullPath}`
      window.entryUrl = url // 将后面的参数去除
    }
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }
  window.scrollTo(0, 0)
  setTimeout(() => {
    store.commit('handleSpinShow', false)
  }, 100)
})

export default router
